import type { ReactNode } from 'react'

/**
 * El aviso de que no hay horas que elegir: un icono, lo que pasa y, debajo, qué hacer.
 *
 * Era una frase suelta en gris, y en un formulario lleno de campos se leía como
 * texto de relleno en vez de como el estado de la lista de horas. Con icono y dos
 * renglones se reconoce de un vistazo, en el diálogo de alta y en el de reprogramar.
 */
export function SlotsEmpty({ icon, title, body }: { icon: ReactNode; title: string; body?: string }) {
  return (
    <div className="dash-slots-empty" role="status">
      <span className="dash-slots-empty-icon" aria-hidden="true">{icon}</span>
      <strong>{title}</strong>
      {body ? <p>{body}</p> : null}
    </div>
  )
}
